import { jsx as _jsx } from "react/jsx-runtime";
import SpeakerModal from 'screens/DashboardScreen/components/SpeakerModal';
import { Speaker } from 'api/speaker';
import { useCallback, useMemo } from 'react';
import { SpeakersContext } from './speakers-context';
const SpeakerEditorModal = ({ editorController, onSubmit, onClose, replacedSpeaker, language, isCaptionMode, defaultSpeakerColor, replaceEverywhere, documentSpeakersOnly, speakerNode, }) => {
    const isCitation = speakerNode !== null
        && Speaker.getNotForTraining(speakerNode) === 'citation';
    const removeSpeaker = () => {
        if (speakerNode !== null) {
            editorController.handleRemoveSpeaker(speakerNode);
        }
        onClose();
    };
    const getEditorSpeaker = (id) => {
        var _a;
        return (_a = editorController.speakers.documentSpeakers.find((speaker) => speaker.id === id || speaker.dbid === id)) !== null && _a !== void 0 ? _a : null;
    };
    const queryDocumentSpeakers = useCallback((searchText) => editorController.speakers.documentSpeakers.filter((speaker) => speaker.matches(searchText)), [editorController]);
    const contextValue = useMemo(() => {
        var _a;
        return ({
            queryDocumentSpeakers,
            projectLanguage: language,
            diarizationCode: (_a = replacedSpeaker === null || replacedSpeaker === void 0 ? void 0 : replacedSpeaker.diarizationCode) !== null && _a !== void 0 ? _a : null,
        });
    }, [queryDocumentSpeakers, language, replacedSpeaker]);
    return (_jsx(SpeakersContext.Provider, { value: contextValue, children: _jsx(SpeakerModal, { mode: "select", onSubmit: onSubmit, removeSpeaker: removeSpeaker, onClose: onClose, languages: language, documentSpeakersOnly: documentSpeakersOnly, isCaptionMode: isCaptionMode, defaultSpeakerColor: defaultSpeakerColor, replacedSpeaker: replacedSpeaker, isReplacedWithCitation: isCitation, replaceEverywhere: replaceEverywhere, getEditorSpeaker: getEditorSpeaker }) }));
};
export default SpeakerEditorModal;
